export const actionTypes = {
    NOTIFICATION_GET_SUCCESS: 'NOTIFICATION/GET_SUCCESS',
    NOTIFICATION_GET_ERROR: 'NOTIFICATION/GET_ERROR',
    NOTIFICATION_LOAD_MORE: 'NOTIFICATION/LOAD_MORE',
    NOTIFICATION_SET_VIEWED_SUCCESS: 'NOTIFICATION/SET_VIEWED_SUCCESS',
    NOTIFICATION_SET_VIEWED_ERROR: 'NOTIFICATION/SET_VIEWED_ERROR',
    NOTIFICATION_LOADING: 'NOTIFICATION/LOADING',
    NOTIFICATIONS_OPEN: 'NOTIFICATIONS/OPEN',
};
